import {createContext, useEffect, createRef, useRef, useState} from 'react'

const ProductContext = createContext()

export const ProductProvider = ({children})=>{

  const [productInfo, setProductInfo] = useState({
    category: '',
    title: '',
    description: '',
    sku:'',
    tags: [],
    // ... other properties
  });
  const [images, setImages] = useState([])
  const [previewImg, setPreviewImg] = useState('')
  const [thumbnails, setThumbnails] = useState([])
  const [modal, setModal] = useState(false)
  const currentIndex = parseInt(images.indexOf(previewImg))
  let thumbnailRef = createRef()
  let modalThumbnailRef = useRef(null)
  const sliderRef = useRef(null)
  const [slideCount, setSlideCount] = useState(0)
  const [slideLength, setSlideLength] = useState(0)
  // const [quantityCount, setQuantityCount] = useState(0)
  // const [cartItems, setCartItems] = useState([])
  // const [showCart, setShowCart] = useState(false)
  // const [total, setTotal] = useState(0)
  const productImgRef = useRef()
  const productTitleRef = createRef(null)
  // const productPriceRef = useRef()
  // const productQuantityRef = useRef()

  useEffect(() => {

    thumbnailActive()
    modalThumbnailActive()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewImg, modal])
  

  const previewDisplay = (e)=>{
    // CHANGE PREVIEW IMG ON CLICK
    setPreviewImg(images[e.target.id])   
  }

  const lightBox = ()=>{
    setModal(true)
  }

  const close = ()=>{
    setModal(false)
  }

  const nextPreview = ()=>{
    if(images.length-1!==0){ 
      if(currentIndex >= images.length-1){
        setPreviewImg(images[currentIndex % (images.length-1)])
      }else{
        setPreviewImg(images[currentIndex+1])
      }
    }
  }

  const prevPreview = ()=>{
    if(currentIndex <1){
      setPreviewImg(images[images.length-1])
    }else{
      setPreviewImg(images[currentIndex-1])
    }
  }

  const thumbnailActive = () => {
    const currentRef = thumbnailRef.current;
    if (currentRef) {
      currentRef.childNodes.forEach((img) => {
        img.classList.remove('border-2', 'border-primary');
        img.classList.add('border', 'border-[#C4C4C4]');
        img.firstElementChild.classList.remove('opacity-50');
      });

      if (currentRef.childNodes[currentIndex]) {
        currentRef.childNodes[currentIndex].classList.remove('border','border-[#C4C4C4]');
        currentRef.childNodes[currentIndex].classList.add('border-2', 'border-primary');
        currentRef.childNodes[currentIndex].firstElementChild.classList.add('opacity-50');
      }
    }
  };

  const modalThumbnailActive = () => {
    if (modal) {
      const currentRef = modalThumbnailRef.current;
      if (currentRef && currentRef.parentElement) {
        const modalThumbnailImgs = currentRef.parentElement.childNodes;
        modalThumbnailImgs.forEach((img) => {
          img.classList.remove('border-2', 'border-primary');
          img.firstElementChild.classList.remove('opacity-50');
        });

        if (modalThumbnailImgs[currentIndex]) {
          modalThumbnailImgs[currentIndex].classList.add('border-2', 'border-primary');
          modalThumbnailImgs[currentIndex].firstElementChild.classList.add('opacity-50');
        }
      }
    }
  };

  const nextSlide = ()=>{
    // let slideLength = sliderRef.current.childElementCount
    if(slideCount > slideLength -2 || (slideCount > slideLength -3 && window.innerWidth > 640)){
      setSlideCount(slideCount)
      sliderRef.current.style.transform = `translateX(-${100 * (slideCount)}%)`
    }else{
      setSlideCount(slideCount+1)
      sliderRef.current.style.transform = `translateX(-${100 * (slideCount+1)}%)`
    }
  }

  const prevSlide = ()=>{
    if(slideCount === 0 ){
      setSlideCount(slideCount)
      sliderRef.current.style.transform = `translateX(-${100 * (slideCount)}%)`
    }else{
      setSlideCount(slideCount- 1)
      sliderRef.current.style.transform = `translateX(-${100 * (slideCount-1)}%)`
    }
  }

  // const quantity = (e)=>{
  //   let action = e.target.innerText
  //   if(action ==='-'){
  //     setQuantityCount((quantityCount)=>(Math.max(quantityCount - 1, 0))) 
  //   }else if(action === '+'){
  //     setQuantityCount((quantityCount)=>(Math.min(quantityCount + 1, 100))) 
  //   }else{
  //     setQuantityCount(()=>(Math.min(parseInt(e.target.value), 100)))
  //   }
  // }

  // const cartDisplay = ()=>{
  //   setShowCart(!showCart)
  // }

  // const addCart = (e)=>{
  //   if(quantityCount < 1){
  //     setQuantityCount(quantityCount+1)
  //   }
    
  //   setCartItems(()=>[
  //     {
  //       'img': thumbnails[0],
  //       'title': productTitleRef.current.innerText, 
  //       'price': productPriceRef.current.innerText,
  //       'quantity': (productQuantityRef.current.value <1? 1 : productQuantityRef.current.value)
  //     }
  //   ])
      
  //   setTotal(productQuantityRef.current.value <1? 1 : productQuantityRef.current.value)
  // }

  // const deleteItem = (e)=>{
  //   let product = e.target.parentElement.parentElement.parentElement.childNodes[1].firstElementChild.textContent
  //   setCartItems(cartItems.filter((item)=>(item.title !== product)))
  //   setTotal(0)
  // }


  return (
    <ProductContext.Provider value={{
      productInfo,
      setProductInfo,
      images, 
      setImages,
      thumbnails,
      setThumbnails, 
      thumbnailRef, 
      previewImg,
      setPreviewImg,
      modal, 
      modalThumbnailRef,
      sliderRef,
      // quantityCount,
      // cartItems,
      // showCart,
      // total,
      productImgRef,
      productTitleRef,
      // productPriceRef,
      // productQuantityRef,
      // addCart,
      // setQuantityCount,
      previewDisplay, 
      lightBox,
      close, 
      nextPreview,
      prevPreview, 
      nextSlide, 
      prevSlide,
      slideCount,
      setSlideLength,
      // quantity,
      // cartDisplay, 
      // deleteItem
    }}>
      {children}
    </ProductContext.Provider>
  )
}

export default ProductContext